import { type FeatureFlagsIntegration, getClient } from '@sentry/browser';
import { useEffect } from 'react';
import { useFeatureFlags } from './FeatureFlagsContext';

export const useSentryFeatureFlags = () => {
  const { flags, loaded } = useFeatureFlags();

  useEffect(() => {
    if (!loaded) return;
    const sentryFlags =
      getClient()?.getIntegrationByName<FeatureFlagsIntegration>(
        'FeatureFlags',
      );
    for (const [name, value] of Object.entries(flags)) {
      if (typeof value === 'boolean') {
        sentryFlags?.addFeatureFlag(name, value);
      }
    }
  }, [flags, loaded]);
};
